<template>
  <!--
    name: 覃刚
    function: nhf管理
    date: 2021-03-09
 -->
  <div class="listContent operation_log_class">
    <a-form :form="form" class="headForm">
      <a-row :gutter="24">
        <a-col :span="4">
          <a-form-item label="配方">
            <a-input
              v-decorator="['formulaKeyword']"
              @pressEnter="
                getList({ current: 1, pageSize: pagination.pageSize })
              "
              placeholder="请输入配方名称/代码"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="线路">
            <a-select v-decorator="['lineId']" placeholder="选择线路">
              <a-select-option
                v-for="el in lineList"
                :key="el.id"
                :value="el.id"
              >
                {{ el.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item label="动物类型">
            <animal-select  @change="anmimlChange" :val="animal" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="分类">
            <a-select
              allowClear
              v-decorator="['typeClassify']"
              style="width: 100%"
              placeholder="选择配方分类"
            >
              <a-select-option :value="0"> 未分类 </a-select-option>
              <a-select-option :value="1"> 自产配方 </a-select-option>
              <a-select-option :value="2"> 代工配方 </a-select-option>
              <a-select-option :value="3"> 定制配方 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="状态">
            <a-select
                allowClear
                v-decorator="['status']"
                style="width: 100%"
                placeholder="全部"
            >
              <a-select-option :value="0">显示</a-select-option>
              <a-select-option :value="1">隐藏</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4" class="submitBtnBox">
          <a-button
            type="primary"
            class="btnMar"
            @click="getList({ current: 1, pageSize: pagination.pageSize })"
          >
            查询
          </a-button>
          <a-button class="" @click="resetFields"> 清空 </a-button>
        </a-col>
      </a-row>
    </a-form>

    <div class="content_class">
      <a-space style="margin: 20px 10px 0 20px">
        <template v-for="el in buttonList">
          <template v-if="el.code.indexOf('third') < 0">
            <a-button
              :key="el.id"
              :type="
                el.code === 'add'
                  ? 'primary'
                  : el.code === 'delete'
                  ? 'danger'
                  : ''
              "
              :class="{
                enable: !isDelete && el.code === 'show',
                forbidden: !isDelete && el.code === 'hide',
              }"
              :ghost="el.code === 'delete'"
              :disabled="
                (isDelete &&
                  (el.code === 'delete' ||
                    el.code === 'simulation' ||
                    el.code === 'show' ||
                    el.code === 'hide')) ||
                (el.code === 'viewDetails' && isEdit)
              "
              @click="clickFunc(el.path, el.code)"
            >
              {{ el.name }}
            </a-button>
          </template>
        </template>
        <template v-if="selectedRowKeys.length > 0">
          <a-tag> 已选择 {{ selectedRowKeys.length }} 个配方 </a-tag>
        </template>
      </a-space>
      <a-table
        :columns="columns"
        :data-source="list"
        ref="listRef"
        class="tableBox"
        :scroll="{ y, x: 1000 }"
        :pagination="pagination"
        rowKey="id"
      >
        <template slot="formulaName" slot-scope="t,r">
          <a @click="showAddFunc(r)">{{ t }}</a>
        </template>
        <div slot="typeClassify" slot-scope="text">
          {{ typeObj[text] }}
        </div>
        <div slot="name8" slot-scope="text, record">
          <a style="margin-right: 10px" @click="showAddFunc(record)">查看</a>
          <a style="margin-right: 10px" @click="showRestoreConfirm(record)">恢复</a>
          <!-- <a :disabled="!record.fileUrl" @click="e => scanPriceList(e,record)">报表</a> -->

          <!-- <a-dropdown v-if="record.version" style="width:90px">
          <a>报表</a>
          <a-menu slot="overlay" @click="e => scanPriceList(e,record)">
            <a-menu-item key="1">配方报表</a-menu-item>
            <a-menu-item key="2">生产报表</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> Button <a-icon type="down" /> </a-button>
        </a-dropdown>
        <a v-else disabled>报表</a> -->
        </div>
      </a-table>
    </div>
    <!-- 查看 -->
    <a-modal
      title="查看配方"
      :visible="showAdd"
      :confirm-loading="confirmLoading"
      @ok="addSubmit"
      @cancel="showAddFunc"
      cancelText="关闭"
      :maskClosable="false"
      :footer="null"
      width="800px"
      class="scanBox"
      :destroyOnClose="true"
    >
      <BlendAdd ref="add" :rowId="rowId" />
      <div class="btnFooter">
        <a-button @click="showAddFunc"> 关闭 </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import BlendAdd from './BlendComponent/BlendAdd.vue'
// import AnimalList from '@/components/Common/components/AnimalList'
// import FormulaEdit from './FormulaAdministration/FormulaEdit'
import moment from 'moment';
import AnimalSelect from "@/components/Nhf/Compound/select/AnimalSelect.vue";
export default {
  components: {
    AnimalSelect,
    BlendAdd,
    // FormulaEdit
  },
  props: {
    menuBtnList: {
      type: Array,
      default() {
        return [];
      },

    },
  },
  data() {
    return {
      buttonList: [],
      factoryList: [],
      treeList: [],
      group: [],
      lineList: [],
      animalTypeName: '',
      animal: [],
      // factoryList: [],
      y: 500,
      rowId: '',
      typeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      typeList2: [],
      form: this.$form.createForm(this, { name: 'rawMaterialList' }),
      confirmLoading: false,
      showAdd: false,// 是否显示新增
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({ current, pageSize })
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({ current: 1, pageSize })
        } //每页多少条
      },
      list: [],
      columns: [
        {
          title: '配方名称',
          dataIndex: 'formulaName',
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: 'formulaName' },
        },
        {
          title: '分类',
          dataIndex: 'typeClassify',
          width: 100,
          scopedSlots: { customRender: 'typeClassify' },
        },
        {
          title: '代码',
          dataIndex: 'formulaCode',
          ellipsis: true,
          width: 140,
        },
        {
          title: '动物类型',
          dataIndex: 'animalTypeName',
          ellipsis: true,
          width: 120,
        },
        {
          title: '工厂名称',
          dataIndex: 'factoryName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '排序',
          dataIndex: 'sortNum',
          ellipsis: true,
          width: 80,
        },
        {
          title: '用户',
          dataIndex: 'userName',
          width: 90,
          ellipsis: true,
        },
        {
          title: '编辑时间',
          dataIndex: 'updateTime',
          width: 170,
          ellipsis: true,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 170,
          ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'name8',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'name8' },
        }
      ],
      searchData: {},
      userList: [],
      typeObj: {
        0: '未分类',
        1: '自产配方',
        2: '代工配方',
        3: '定制配方',
      }
    }
  },
  watch: {
    menuBtnList: {
      handler(val) {
        this.getBtn(val)
      },
      deep: true
    },
    group: {
      handler() {
        this.form.setFieldsValue({ factoryIdList: [] })
      },
      deep: true
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item => item.id === i)[0]
          })
        },
        getCheckboxProps: record => ({
          props: {
            disabled: !this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length >= 20
          },
        }),
      }
    },
    isDelete() {
      return this.selectedRowKeys.length === 0
    },
    isEdit() {
      return this.selectedRowKeys.length !== 1
    },

  },
  created() {
    this.getTypeList2()
    // this.getUserList()
    this.getTreeList()
  },
  mounted() {
    // this.y = this.$refs.listRef.$el.offsetHeight - 116
    this.setParams()
    this.getBtn(this.menuBtnList)
  },
  methods: {
    setParams() {
      let formulaFormStr = window.localStorage.getItem('blendForm')
      let blendForm = formulaFormStr ? JSON.parse(formulaFormStr) : {}
      if (blendForm.animalTypeName) this.animalTypeName = blendForm.animalTypeName
      this.form.setFieldsValue(blendForm)
    },
    getBtn(val) {
      let formula = val.find(el => el.code === 'blend') || {}
      if (formula.children) {
        this.buttonList = formula.children.filter(el => el.code !== "export") || []
      }
    },
    changeForm(data) {
      this.form.setFieldsValue({ ...data })
      this.animalTypeName = data.animalTypeName
      this.searchData = { ...this.searchData, ...data }
    },
    anmimlChange(val) {
      this.animal = val;
      this.searchData.animalTypeCode = [...val].pop();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    groupChage(val) {
      if (val && val.length) {
        let deptId = val && val.length ? val[val.length - 1] : undefined
        let params = { current: 1, size: 1000, deptId }
        this.$http.get('/iot-factory/factory/selectFactoryInfoPage', { params }).then(res => {
          let { success, data } = res || {}
          if (success) {
            let { records } = data || {}
            this.factoryList = records || []
          }
        })
      } else {
        this.factoryList = []
      }
    },
    dealList(list = []) {
      list.map(el => {
        if (el.children && el.children.length > 0) {
          this.dealList(el.children)
        }
        el.edit = false
        el.scopedSlots = { title: 'custom' }
      })
      return list
    },
    getTreeList() {
      this.$http.get('/iot-system/dept/tree').then(res => {
        let { success, data = [] } = res || {}
        if (success) {
          this.treeList = this.dealList(JSON.parse(JSON.stringify(data)))
          // this.cache = this.dealList(JSON.parse(JSON.stringify(data)))
        }
      })
    },
    getTypeList2() {
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`, { params }).then(res => {
        let { success, data } = res
        if (success) {
          let { records } = data || {}
          records && records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList2 = records || []
          this.getLineList()
        }
      })
    },
    getLineList() {
      let staffId = window.localStorage.getItem('staffId')
      if (!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        // let {success,data} = res || {}
        if (data && data.length > 0) {
          data = data.sort((a, b) => a - b)
          let lineList = []
          this.typeList2 && this.typeList2.forEach(el => {
            if (data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.getList()
          // if (!this.form.getFieldValue('lineId')) this.form.setFieldsValue({ lineId: this.lineList[0].id || '' })
          // setTimeout(() => {
          //   this.getList()
          // }, 0);
        }
      })
    },
    getFactoryList(name) {
      setTimeout(() => {
        this.$http.get("/iot-factory/factory/selectFactoryInfoPage", { params: { size: 20, current: 1, name } }).then(res => {
          if (res?.data && res?.data?.records) {
            this.factoryList = res.data.records
          }
        })
      }, 300);
    },
    getUserList(name) {
      setTimeout(() => {
        this.$http.get('/iot-user/userInfoListPage', { params: { size: 20, current: 1, name } }).then(res => {
          if (res?.data && res?.data?.records) {
            this.userList = res.data.records
          }
        })
      }, 300);
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0);
    },
    getTypeList(parentId = '0', record, flag) {
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let { success, data = [] } = res;
        if (success) {
          data && data.map(el => {
            el.value = el.id
            el.label = el.name
            el.isLeaf = !el.hasChildren
            return el
          })
          if (record) {
            if (data.length) {
              record.children = data
            } else {
              record.isLeaf = true
            }
            this.typeList = [...this.typeList];
          } else {
            this.typeList = data
          }
          if (flag) this.getLineList()
          if (parentId === '0') {
            this.getTypeList(this.typeList[0].id, this.typeList[0], true)
          }
        } else {
          this.typeList = []
        }
      })
    },
    resetFields() {
      this.group = []
      this.factoryList = []
      // this.form.resetFields()
      window.localStorage.removeItem('blendForm')
      this.animal = [];
      this.searchData.animalTypeCode = undefined
      this.form.setFieldsValue({ formulaKeyword: undefined, typeArr: [], factoryId: undefined,
        staffId: undefined, updateTime: null, factoryKeyword: null, updateUserName: null,
        factoryIdList: [], 'typeClassify': undefined,lineId: undefined  })
    },
    getList(pagination) {
      window.localStorage.removeItem('blendForm')
      let factoryId = window.localStorage.getItem('factoryId');
      this.selectedRows = []
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      this.form.validateFields((err, data) => {
        let { updateTime, factoryIdList = [], ...newdata } = data
        if (this.group.length > 0 && factoryIdList.length === 0) {
          this.$message.warning('请选择工厂')
          return
        }
        let updateTimeStart = updateTime && updateTime[0] ? moment(updateTime[0]).format('YYYY-MM-DD 00:00:00') : undefined
        let updateTimeEnd = updateTime && updateTime[1] ? moment(updateTime[1]).format('YYYY-MM-DD 23:59:59') : undefined
        let params = {
          ...this.searchData,
          factoryIdList,
          ...newdata,
          formulaType: 2,
          factoryId:factoryId,
          // query: {current,size:pageSize},
          current, size: pageSize,
          updateTimeStart, updateTimeEnd,
          // animalTypeCode: typeArr.length ? typeArr[typeArr.length - 1] : undefined,

        }
        this.$http.get('/nhf-app/archivedFormula/page', { params }).then(res => {
          // this.$http.post('/nhf-app/formulaNhf/formulaNhfCondPage',params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0 } = data;
            this.pagination.current = current
            this.pagination.total = total
            this.list = records || []
          } else {
            this.$message.error('查询失败')
          }
          window.localStorage.setItem('fileUrl', '')
        })
      })
    },
    deleteData() {
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料删除吗？',
        cancelText: '取消',
        okText: '确定',
        onOk() {
        },
        onCancel() {
        },
      });

    },
    scanPriceList({ key: formulaReportType }, record) {
      // 查看价格
      // this.$router.push(`/print/Printing?name=报表打印&id=${record.id}`)
      let routeData = this.$router.resolve({
        path: `/print/Printing?name=${record.updateUserName}的${record.formulaName}配方&id=${record.id}&formulaReportType=${formulaReportType}`
      });
      // window.localStorage.setItem('fileUrl',record.fileUrl)
      window.open(routeData.href, "_blank");
    },
    addSubmit() {
      // 新增提交
      // this.$refs['add'].form.validateFields((err, values) => {
      // })
      this.showAddFunc()
    },
    clickFunc(functionName, type) {
      this[functionName](type)
    },
    viewDetails() {
      this.showAddFunc(this.selectedRows[0])
    },
    showAddFunc(record) {
      // 新增显示或关闭
      // if(record && record.id){
      //   this.rowId = record.id
      // }
      // this.$nextTick(() => {
      //   this.showAdd = !this.showAdd
      // })
      this.form.validateFields((err, params) => {
        window.localStorage.setItem('blendForm', JSON.stringify(params))
        this.$router.push(
          {
            path: '/archive-data/archive-data-blend/archive-data-blend-detail',
            query: {
              name: '混合日粮归档详情',
              id: record.id,
              factoryId: record.factoryId,
            },
          }
        )
      })
    },
    editSubmit() {
      // 编辑提交
      // this.$refs['edit'].form.validateFields((err, values) => {
      // })
      this.showEditFunc()
    },
    showEditFunc(type) {
      // 编辑显示或关闭
      if (type === 'edtiBtn') {
        if (this.selectedRows.length > 1) {
          this.$message.warning('编辑只能选中一条数据')
        } else if (this.selectedRows.length === 0) {
          this.$message.warning('请选中需要编辑的数据')
        } else {
          this.showEdit = !this.showEdit
        }
      } else {
        this.showEdit = !this.showEdit
      }
    },

    showRestoreConfirm(record) {
      const _this = this;
      this.$confirm({
        title: '配方数据恢复',
        content: `确认将配方《${record.formulaName}》的数据进行恢复吗？`,
        cancelText: '取消',
        okText: '确定',
        onOk() {
          return _this.restoreFormula(record.id);
        },
        onCancel() {
          // 取消操作，无需额外处理
        }
      });
    },

    restoreFormula(formulaId) {
      const params = { formulaId };
      return this.$http.get('/nhf-app/archivedFormula/restore', { params }).then(res => {
        const { success, message } = res;
        if (success) {
          this.$message.success('配方恢复成功');
          // 恢复成功后刷新列表
          this.getList();
        } else {
          this.$message.error(message || '配方恢复失败');
        }
      }).catch(err => {
        this.$message.error('配方恢复失败' + err);
      });
    }
  }
}
</script>
<style lang="scss">
.scanBox {
  .ant-modal-body {
    padding: 0 10px 0 10px;
  }
}
.operation_log_class .ant-form-item-label {
  width: 62px;
}
</style>

<style lang="scss" scoped>
.btnFooter {
  border-top: 1px solid #e8e8e8;
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.copy-tips {
  position: absolute;
  top: -44px;
  left: -33px;
  background: #1890ff;
  padding-top: 50px;
  width: 40px;
  height: 64px;
  text-align: center;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  .copy-tags {
    color: #fff;
    font-size: 12px;
    transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -o-transform: rotate(45deg);
  }
}
.operation_log_class {
  height: calc(100% - 71px);
  border-radius: 5px;
  .title_class {
    background-color: #fff;
    margin-bottom: 21px;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .title_search_class {
      display: flex;
      flex-wrap: wrap;
      flex: 2;
      .search_change_class {
        display: flex;
        align-items: center;
        margin: 0 10px 10px 0;
        .text_class {
          width: 100px;
        }
      }
    }
    .title_btn_class {
      flex: 0.6;
      .search_class {
        margin-right: 10px;
      }
    }
  }
  .content_class {
    background-color: #fff;
    border-radius: 5px;
    // height: calc(100% - 100px);

    .tableBox {
      height: calc(100% - 20px);
      padding-bottom: 0;
    }
  }
}
</style>
